/* @ngInject */
export default class TypeService {
  constructor($q, $sails) {
    this.$sails = $sails;
    this.$q = $q;
  }

  getAllTypes() {
    return this.$sails.get('/type/').catch((error) => {
      console.error(error);
      return this.$q.reject(error.data);
    });
  }

  getType(typeId) {
    return this.$sails.get(`/type/${typeId}`).catch((error) => {
      console.error(error);
      return this.$q.reject(error.data);
    });
  }

  create(newType) {
    return this.$sails.post('/type', newType);
  }

  update(typeId, newType) {
    return this.$sails.put(`/type/${typeId}`, newType);
  }

  destroy(typeId) {
    return this.$sails.delete(`/type/${typeId}`);
  }
}
